import $ from '@nuskin/nuskinjquery';
import {nuskin, Base64} from '@nuskin/ns-util';
import {UserService} from '@nuskin/ns-account';

const eidLogin = () => {
    let queryString = window.location.search.substring(1);
    const redirect = window.location.pathname;
    let hashValue = "";
    if (window.location.hash) {
        queryString = window.location.hash.substring(window.location.hash.indexOf("?"), window.location.hash.length).substring(1);
        hashValue = window.location.hash.substring(0, window.location.hash.indexOf("?"));
    }

    if (queryString) {
        const queryObject = $.getQueryParameters(queryString);
        if (queryObject.eid) {
            const user = UserService.getUser();

            const removedParameters = {"redirectURL": "redirectURL", "eid": "eid"};
            let extraQueryParams = "";
            for (let key in queryObject) {
                if (!removedParameters.hasOwnProperty(key)) {
                    extraQueryParams += "&" + key + "=" + queryObject[key];
                }
            }

            if (user && Base64.decode(queryObject.eid).indexOf(user.id) >= 0) {
                user.eid = queryObject.eid;
                UserService.setUser(user);
                window.location = redirect + (extraQueryParams.length > 0 ? '?' + extraQueryParams.substr(1) : '') + hashValue;  // user already logged in, redirect to self minus eid and redirectUrl
            } else {
                let configPathParam = "";
                if ((typeof nuskin !== 'undefined') && nuskin.configurationPath) {
                    configPathParam = "&configPath=" + nuskin.configurationPath;
                }
                window.location = nuskin.account.EID_LOGIN_PATH + "?redirectURL=" + redirect + "&eid=" + queryObject.eid + configPathParam + extraQueryParams + hashValue;
            }
        }
    }
}

export default eidLogin;
